import React from "react";
import Slider from "react-slick";
import { Box } from "@mui/material";

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  adaptiveHeight: false,
  arrows: false,
};

const BannerCarousel = ({ banners }) => {
  if (!banners || banners.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mb: 2 }}>
      <Box
        sx={{
          height: { xs: "150px", md: "200px" },
          width: { xxs: "100%", xsm: "736px", mds: "992px", sm: "1104px" },
          borderRadius: 4,
          overflow: "hidden",
        }}
      >
        <Slider {...settings}>
          {banners.map((BannerComponent, index) => (
            <Box key={`banner-key-${index}`}>
              <BannerComponent />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default BannerCarousel;
